<div class="content">
  <div class="description">
    {{ 'AUTOMATIONS.EDITOR.TASKS.AI_ASSISTANT_ACTION.DESCRIPTION' | translate }}
  </div>
  <ng-container>
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.AI_ASSISTANT_ACTION.REQUEST_TEXT' | translate }}
      </glxy-label>
      <textarea
        id="request-text"
        matInput
        [formControl]="requestTextControl"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="8"
        [required]="true"
        #promptTextArea
      ></textarea>
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        (variableSelected)="insertVariable('request-text', requestTextControl, $event)"
        dontIncludeDefaultCategories="true"
      ></automata-automation-variable-menu>
      <glxy-hint align="end">{{ promptTextArea.value?.length || 0 }}/2000</glxy-hint>
      <glxy-error *ngIf="requestTextControl.hasError('required')">
        {{ 'COMMON.REQUIRED' | translate }}
      </glxy-error>
    </glxy-form-field>
  </ng-container>
</div>
